import { addPost } from './../../../redux/profileReducer';
import MyPosts from './MyPosts';
import {connect} from 'react-redux';

const mapStateToProps = (state) => ({
		postsData: state.profilePage.postsData,
		newPostText: state.profilePage.newPostText
    });

const MyPostsContainer = connect(mapStateToProps, { addPost })(MyPosts);

export default MyPostsContainer;